<template>
  <div :class="$options.name">
    <v-dialog v-model="dialog" persistent max-width="340">
      <v-card>
        <v-card-title class="title">
          Вы действительно желаете удалить {{ elementsText }} слоя?
        </v-card-title>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn color="error" text @click="dialog = false">Отмена</v-btn>
          <v-btn color="success" text @click="onConfirm">Удалить {{ elementsText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import { declensionOfNumerals } from '@/utils/string';

export default {
  name: 'remove-geometry-confirmation',
  mixins: [DialogBusMixin],
  data: () => ({
    itemId: null,
  }),
  computed: {
    elementsText() {
      const text = ['элемент', 'элемента', 'элементов'];
      if (!Array.isArray(this.itemId) || this.itemId.length === 1) {
        return text[0];
      }
      return `${this.itemId.length} ${declensionOfNumerals(this.itemId.length, text)}`;
    },
  },
  methods: {
    beforeOpen({ itemId }) {
      this.itemId = itemId;
    },

    onConfirm() {
      this.$emit('confirmed', this.itemId);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.title {
  word-break: break-word;
}
</style>
